import PropTypes from 'prop-types';
import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';

import {
  cancelHonorAward,
  deleteHonorAward,
  scrolledToHonorAward,
} from 'shared/portfolio/actions/honor-awards';

import PortfolioFormFooter from 'src/components/PortfolioFormFooter';
import HonorAwardsForm from './honor-awards-form';
import HonorAwardsFormWrapper from './honor-awards-form-wrapper';
import FormCard from '../form-card';

const propTypes = {
  honorAward: PropTypes.object.isRequired,
};

const HonorAwardsFormCard = ({honorAward}) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (honorAward.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToHonorAward(honorAward._id));
      }, 550);
    }
  }, [dispatch, honorAward._id, honorAward.scrollTo]);

  return (
    <FormCard ref={ref} id={honorAward._id}>
      <HonorAwardsFormWrapper initialValues={honorAward}>
        <h4 className="portfolio-sections add-edit-header">
          {honorAward.new ? 'Add' : 'Edit'} an Honor or Award
        </h4>
        <HonorAwardsForm />
        <PortfolioFormFooter
          _id={honorAward._id}
          onCancel={() => dispatch(cancelHonorAward(honorAward))}
          onDelete={() => dispatch(deleteHonorAward(honorAward._id))}
          formName="portfolio honor-awards honor-awards-form"
        />
      </HonorAwardsFormWrapper>
    </FormCard>
  );
};

HonorAwardsFormCard.propTypes = propTypes;

export default HonorAwardsFormCard;
